import { CognitoUserPool } from 'amazon-cognito-identity-js';

// Menu identifiers - use these instead of display labels for activeMenu state
export const MENU_IDS = {
  LIBRARY: 'library',
  RESOURCES: 'resources',
  RECORDINGS: 'recordings',
  UPLOAD: 'upload',
  STREAM: 'stream',
  SIMULATOR: 'simulator',
};

// External URLs
export const PRIVACY_POLICY_URL = 'https://www.talktrees.ai/privacy';
export const PLAYBOOK_URL = 'http://www.talktrees.ai/playbooks';

export const PIPELINE_ID = '2026-talktrees-upload-v1';

// Dev account configuration
//
// const cognitoPoolData = {
//   UserPoolId: 'us-east-1_4bJHVWiv8',
//   ClientId: '7i942tsjok6n1ibtacprn1patj',
// };
// export const API_BASE_URL = 'https://api.dev.hatproject.org/';
// export const COGNITO_TOKEN_URL = 'https://hat-server-users-dev.auth.us-east-1.amazoncognito.com/oauth2/token';
// export const WS_URL = 'wss://ws.dev.hatproject.org/v1aux';

// Prod account configuration

const cognitoPoolData = {
  UserPoolId: 'us-east-1_JcNQ0Ua6D',
  ClientId: '74k490tr7ua2l114j8nk1fgcc4',
};
export const API_BASE_URL = 'https://api.hatproject.org/';
export const COGNITO_TOKEN_URL = 'https://hat-server.auth.us-east-1.amazoncognito.com/oauth2/token';
export const WS_URL = 'wss://ws.hatproject.org/v1aux';

// Create and export the CognitoUserPool instance
export const userPool = new CognitoUserPool(cognitoPoolData);
